import React,{Component,useState, useEffect} from 'react';
import styles from '../styles/pages/search.scss'
import _ from 'lodash'
import { formPost } from '../api';
import Loading from '../components/common/loading'
import NoData from '../components/common/noData'
import {withRouter} from 'next/router'
import { asArray, getResponseData } from '../util/apiResponse'


const  Search = props=>{
    const {searchVisible} = props
    const [searchVal,setSearchVal] = useState(props.router.query.v!='null'?props.router.query.v:'');
    const [historyVisible,setHistoryVisible] = useState(false);
    const [allRecordNum,setallRecordNum] = useState()
    const [leagues,setLeagues] = useState([])
    const [players,setPlayers] = useState([])
    const [teams,setTeams] = useState([])
    const [isLoading,setIsLoading] = useState(props.router.query.v?true:false)
    const [historyList,setHistoryList] = useState([])
    const [artList,setArtList] = useState([])
    const handleFocus = () =>{
        if(!searchVal){
            setHistoryVisible(true);
        }else{
            setHistoryVisible(false);
        }
    }
    const handleChange = (e)=>{
        (e)
        handleFocus()
        setSearchVal(e.target.value)
    }
    const handleSearch = (value)=>{
        // if(!searchVisible){
        //     props.handleSearch()
        // }
        if(!value && !searchVal){
            return
        }
        if(value){
            setSearchVal(value)
        }
        setIsLoading(true)
        formPost('/new/article/article/homePageSearch',{keyWords: value? value : searchVal}).then(res=>{
            if(res.code==1){
                const data = getResponseData(res, {})
                setallRecordNum(Number(data.allRecordNum) || 0)
                setArtList(asArray(data.articleList))
                setLeagues(asArray(data.leagues))
                setPlayers(asArray(data.players))
                setTeams(asArray(data.teams))
                setIsLoading(false)
                if(!historyList.includes(searchVal)){
                    historyList.unshift(searchVal)
                    setHistoryList(historyList)
                }
                localStorage.setItem("commonSearch",JSON.stringify(historyList))
            } else {
                setallRecordNum(0)
                setArtList([])
                setLeagues([])
                setPlayers([])
                setTeams([])
                setIsLoading(false)
            }
        }).catch(() => {
            setallRecordNum(0)
            setArtList([])
            setLeagues([])
            setPlayers([])
            setTeams([])
            setIsLoading(false)
        })
    }
    const handleKeyUp = (e)=>{
        if(e.keyCode==13){
            handleSearch()
        }
    }
    const handleHisSearch = (value)=>{
        handleSearch(value)
        setHistoryVisible(false)
    }
    const handleClear = ()=>{
        localStorage.removeItem("commonSearch")
        setHistoryList([])
    }
    useEffect(()=>{
        let commonSearch  = localStorage.getItem("commonSearch") ? JSON.parse(localStorage.getItem("commonSearch")) : [];
        setHistoryList(commonSearch)
        if(props.router.query.v){
            handleSearch()
        }
    },[])
    return (
        <div className={['container',styles.search_wrap].join(' ')}>
            <div className={styles.search_header} onMouseLeave={()=>setHistoryVisible(false)}>
                <div className={styles.left_input_box}>
                    <i className={['iconfont',styles.icon_search].join(' ')}>&#xe60a;</i>
                    <input value={searchVal} onFocus={()=>{handleFocus()}} onKeyUp={(e)=>handleKeyUp(e)} onChange={(e)=>{handleChange(e)}} className={styles.search_input} type="text"/>
                    {
                        <div style={{visibility: searchVal? "visible":"hidden"}} className={styles.clear_box} onClick={()=>setSearchVal('')}>
                            <i className={['iconfont',styles.icon_clear].join(' ')}>&#xe606;</i>
                        </div>
                    }
                </div>
                <div className={styles.btn_search} onClick={()=>handleSearch()}>搜索</div>
                {
                        <div style={{display:historyVisible && historyList.length?'':'none'}} className={styles.history_search}>
                            <div className={styles.title}>
                                <span className={styles.text}>历史搜索</span>
                                <span className={styles.btn_clear} onClick={()=>handleClear()}>清空</span>
                            </div>
                            <ul className={styles.history_search_list}>
                                {
                                    historyList.map((v,i)=>{
                                        return (
                                            <li key={i} onClick={()=>{handleHisSearch(v)}}>{v}</li>
                                        )
                                    })
                                }
                            </ul>
                        </div>

                }
            </div>

            {
                isLoading ? (
                    <Loading/>
                ) : (
                    <div className={styles.search_content}>
                        {
                            artList.length ? (
                                <>
                                    <div className={styles.title}>相关文章</div>
                                    <ul className={styles.art_wrap}>
                                        {
                                            artList.map((v,i)=>{
                                                return (
                                                    <li key={v.id}>
                                                        <a href={'/article/artDetail?id='+v.id} target="_blank">
                                                            <span className={styles.title}>{v.title}</span>
                                                            <span className={styles.author_name}>{v.username}</span>
                                                            <span className={styles.release_time}>{v.timeStr}</span>
                                                        </a>
                                                    </li>
                                                )
                                            })
                                        }
                                        {
                                             artList.length%2 !=0 ? <li>&nbsp;</li>: null
                                        }
                                    </ul>
                                </>
                            ) : null
                        }
                        {
                            leagues.length?  (
                                <>
                                    <div className={styles.title}>相关联赛</div>
                                    <table>
                                        <thead>
                                            <tr>
                                                <td className="pl30" align="left">联赛名称</td>
                                                <td align="left">国家或足球机构</td>
                                                <td align="center">球队数量</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                leagues.map((v,i)=>{
                                                    return(
                                                        <tr key={i}>
                                                            <td className="pl30" align="left"><a className={styles.leagueName} href={"/database?leagueId="+v.leagueId} target="_blank"><img src={v.leaguePic} alt=""/>{v.leagueName}</a></td>
                                                            <td align="left"><img src={v.countryPic} alt=""/>{v.country}</td>
                                                            <td align="center">{v.teamNum}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </>
                            )
                            :null
                        }
                    {
                        teams.length ? (
                                <>
                                    <div className={styles.title}>相关球队</div>
                                    <table>
                                            <thead>
                                                <tr>
                                                    <td className="pl30" align="left">球队名称</td>
                                                    <td align="left">联赛或足球机构</td>
                                                    <td align="center">成立时间</td>
                                                    <td align="center">主教练</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    teams.map((v,i)=>{
                                                        return (
                                                            <tr key={i}>
                                                                <td className="pl30" align="left"><a className={styles.team_name} href={'/teamDetail?teamId='+v.teamId} target="_blank"><img src={v.teamPoster} alt=""/><span>{v.teamName}</span></a></td>
                                                                <td align="left"><a className={styles.leagueName} href={"/database?leagueId="+v.teamLeagueId} target="_blank"><img src={v.leaguePoster} alt=""/>{v.teamLeague}</a></td>
                                                                <td align="center">{v.teamTiem}</td>
                                                                <td align="center">{v.teamCoach}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody>
                                    </table>
                                </>
                        ) : null
                    }
                        {
                            players.length ? (
                                <>
                                    <div className={styles.title}>相关球员</div>
                                    <table>
                                        <thead>
                                            <tr>
                                                <td className="pl30" align="left">相关球员名称</td>
                                                <td align="center">位置</td>
                                                <td align="left">球队</td>
                                                <td align="left">国籍</td>
                                                <td align="center">出生年月</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                players.map((v,i)=>{
                                                    return(
                                                        <tr key={i}>
                                                            <td className="pl30" align="left"><img src={v.playerPoster} className={styles.plHeder} /><a className={styles.player_name} href={'/playerDetail?playerId='+v.playerId} target="_blank">{v.playerName}</a></td>
                                                            <td align="center">{v.playerLocation}</td>
                                                            <td align="left"><a className={styles.team_name_wrap} href={'/teamDetail?teamId='+v.teamId} target="_blank"><img src={v.teamPoster} alt=""/><span>{v.teamName}</span></a></td>
                                                            <td align="left"><img src={v.playCountryPoster} alt=""/><span>{v.playCountry}</span></td>
                                                            <td align="center">{v.playBirthday}</td>
                                                        </tr>
                                                    )
                                                })
                                            }

                                        </tbody>
                                    </table>
                                </>

                            ) : !artList.length && !leagues.length &&  !players.length &&  !teams.length ? <NoData /> : null
                        }

                    </div>
                )
            }

        </div>
    )


}

export default withRouter(Search);
